// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import PriceParity20 from './PriceParity20';
import PriceParity20Circle from './PriceParity20Circle';
import PriceParity24 from './PriceParity24';
import PriceParity24Circle from './PriceParity24Circle';
import PriceParity40 from './PriceParity40';
import PriceParity48 from './PriceParity48';

type PriceParityProps = {
    variation: '20' | '20Circle' | '24' | '24Circle' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    PriceParity20,
    PriceParity20Circle,
    PriceParity24,
    PriceParity24Circle,
    PriceParity40,
    PriceParity48,
};

const PriceParity: FC<PriceParityProps> = ({ variation, ...props }) => {
    const variationKey = `PriceParity${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"PriceParity" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default PriceParity;
